import React from "react";

function SvgIcMapPoi039(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M13.995 14.02L14 13h-.5a.5.5 0 010-1h5a.5.5 0 110 1H18s-.002-.213-.002 1.015v1c0 1.23-.91 1.998-1.978 1.998-1.106 0-2.029-.639-2.029-2.095l.004-.877h.001v-.02zm5.004.078C22.664 14.348 24 15 24 15l3.015-1-4.009-3.934L15.988 8 8.97 10.013l-3.905 3.989 2.913 1s1.34-.655 5.018-.905l-.004.818c0 .893.288 1.638.782 2.179-4.27.201-5.797.948-5.797.948 0 1.113 3.587 3.936 8.012 3.936 4.425 0 8.012-2.823 8.012-3.936 0 0-1.526-.747-5.803-.95a3 3 0 00.801-2.076l.001-.918z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi039;
